export enum FormStateEnum {
    detail,
    answer,
    validation
  }
